import {Rating, Stack, css, styled} from '@mui/material';
import {StyledRatingProps} from './types';

export const StyledStack = styled(Stack)`
	flex-direction: row;
	justify-content: space-between;
	padding-inline: 8px;
	margin-top: 8px;
`;

export const StyledRating = styled(Rating)<StyledRatingProps>`
	width: 100%;
	justify-content: space-between;
	margin-left: 12px;
	font-size: 42px;

	${({theme}) => theme.breakpoints.up(375)} {
		margin-left: 16px;
	}

	${({theme}) => theme.breakpoints.up(425)} {
		margin-left: 24px;
	}

	${({theme}) => theme.breakpoints.up(768)} {
		margin-left: 56px;
	}

	${({$hasError, theme}) =>
		$hasError &&
		css`
			& .MuiRating-icon {
				color: ${theme.palette.error.main};
			}
		`}
`;
